// Font configuration for the Hypnobreaker game
// This ensures consistent use of the custom 'm6' font throughout the game

export function animateText(target, speedInMs = 25, delayInMs = 0) {
  // Cancel any existing animation on this target
  if (target._textAnimationTimer) {
    target._textAnimationTimer.destroy();
    target._textAnimationTimer = null;
    console.log('Cancelled ongoing text animation for target');
  }

  // store original text
  const message = target.text;
  const invisibleMessage = message.replace(/[^ ]/g, " ");

  // clear text on screen
  target.text = "";

  // mutable state for visible text
  let visibleText = "";

  // use a Promise to wait for the animation to complete
  return new Promise((resolve) => {
    const timer = target.scene.time.addEvent({
      delay: speedInMs,
      loop: true,
      callback() {
        delayInMs -= speedInMs;
        if (delayInMs > 0) {
          return;
        }
        // if all characters are visible, stop the timer
        if (target.text === message) {
          timer.destroy();
          target._textAnimationTimer = null; // Clear reference
          return resolve();
        }

        // add next character to visible text
        visibleText += message[visibleText.length];

        // right pad with invisibleText
        const invisibleText = invisibleMessage.substring(visibleText.length);

        // update text on screen
        target.text = visibleText + invisibleText;
      },
    });
    
    // Store timer reference on the target for future cancellation
    target._textAnimationTimer = timer;
  });
}



export const FONT_CONFIG = {
  family: 'm6, system-ui, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif',
  fallback: '', // No fallback needed when using system fonts directly
  systemOnly: 'system-ui, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif'
};

// Default text styles with the custom font
export const TEXT_STYLES = {
  default: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '18px',
    fill: '#111111',
    alighn: 'left'
  },
  
  title: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '48px',
    fill: '#111111',
    fontStyle: 'bold'
  },
  
  subtitle: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '32px',
    fill: '#111111'
  },

    
  statement: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '32px',
    fill: '#111111',
    align: 'center'
  },
  
  button: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '18px',
    fill: '#111111',
    fontStyle: 'bold'
  },
  
  small: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '18px',
    fill: '#111111'
  },
  
  conversation: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '24px',
    fill: '#111111',
    wordWrap: { width: 650 }
  },
  
  ui: {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    fontSize: '24px',
    fill: '#111111'
  },
  
  // System-only styles for emoji testing
  systemStatement: {
    fontFamily: FONT_CONFIG.systemOnly,
    fontSize: '32px',
    fill: '#111111',
    align: 'center'
  },
  
  systemButton: {
    fontFamily: FONT_CONFIG.systemOnly,
    fontSize: '18px',
    fill: '#111111',
    fontStyle: 'bold'
  }
};

// Helper function to create text with default font
export function createText(scene, x, y, text, style = 'default', customStyle = {}) {

    // if a custom style object is provided, merge it with the selected style
  let textStyle = typeof style === 'string' ? TEXT_STYLES[style] : { ...TEXT_STYLES.default, ...customStyle };
  if(typeof customStyle === 'object') {
    textStyle = { ...textStyle, ...customStyle };
  }
  return scene.add.text(x, y, text, textStyle);
}

/**
 * Merges custom styles with the default font family.
 * Note: The default font family is always applied and will override any fontFamily specified in customStyle.
 */
export function getTextStyle(customStyle = {}) {
  return {
    fontFamily: FONT_CONFIG.fallback ? `${FONT_CONFIG.family}, ${FONT_CONFIG.fallback}` : FONT_CONFIG.family,
    ...customStyle
  };
}